import { uiSize } from '@utils'

function PlusIcon() {
  return (
    <svg width={uiSize(14)} height={uiSize(14)} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.4'>
      <path d='M12 5v14M5 12h14' />
    </svg>
  )
}

export default PlusIcon
